// TODO: Implement Stripe integration for workspace billing
// This component currently uses mock data and needs to be connected to Stripe API
// for subscription management, billing profiles, and payment processing

import { Button } from '@/components/ui/button'
import { SelectField } from '@/components/ui/select-field'
import { SettingsFieldStack } from '@/components/Settings/SettingsFieldStack'
import { useWorkspaceUrl } from '@/hooks/useWorkspaceUrl'
import { useNavigate } from 'react-router-dom'
import { RotateCw, CreditCard } from 'lucide-react'

export function WorkspaceBillingSection() {
	const navigate = useNavigate()
	const workspaceUrl = useWorkspaceUrl()
	
	// Mock data - no backend integration yet as requested
	const hasSubscription = false
	const selectedBillingProfileId = null
	
	const handleSignUp = () => {
		navigate(`${workspaceUrl}/sign-up`)
	}
	
	const handleBillingProfileChange = (billingProfileId: string | null) => {
		// TODO: Wire to backend when ready
		console.log('Selected billing profile:', billingProfileId)
	}

	// Mock billing profile options
	const billingProfileOptions = [
		{
			value: "profile-1",
			label: "VISA 1882",
			description: "john@example.com • Visa ending in 1882",
			icon: <CreditCard className="h-4 w-4" />
		},
		{
			value: "profile-2", 
			label: "Mastercard 5432",
			description: "jane@example.com • Mastercard ending in 5432",
			icon: <CreditCard className="h-4 w-4" />
		}
	]

	return (
		<SettingsFieldStack>
			<div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
				{/* Subscription field - using SelectField for consistent styling */}
				<SelectField
					label="Subscription"
					value={null} // Always null since it's read-only for now
					onChange={() => {}} // No-op since it's read-only
					options={[]} // Empty options since it's read-only
					placeholder={hasSubscription ? "$5,000/month" : "No HoneyGrid subscription yet"}
					disabled={true}
					leftIcon={<RotateCw className="h-4 w-4" />}
					emptyMessage="No subscription options available"
				/>

				{/* Billing Profile field */}
				<SelectField
					label="Billing Profile"
					value={selectedBillingProfileId}
					onChange={handleBillingProfileChange}
					options={billingProfileOptions}
					placeholder={hasSubscription ? "Select billing profile" : "No billing profiles yet"}
					disabled={!hasSubscription}
					leftIcon={<CreditCard className="h-4 w-4" />}
					searchPlaceholder="Search billing profiles..."
					emptyMessage="No billing profiles found."
				/>
			</div>

			{/* Sign Up button - only show when no subscription */}
			{!hasSubscription && (
				<div className="flex gap-2">
					<Button onClick={handleSignUp} className="text-sm">
						Sign Up
					</Button>
				</div>
			)}
		</SettingsFieldStack>
	)
}
